export default __webpack_public_path__ + "static/media/AFPercentage_Bulk_Update.f6765c56.png";